//@flow
import { connect } from 'react-redux';
import { loginRequest } from '../../modules/Authentication/actions';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import { GenericLogin } from '../../components/common';
import { redirectAfterLogin } from '../../modules/Navigation';

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'login'),
  isRedirectLoading: isLoadingSelector(state, 'redirectAfterLogin'),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: loginInfo => dispatch(loginRequest({ ...loginInfo, redirectPath: ownProps.route.params?.redirect_to })),
  redirectAfterLogin: redirectPath => dispatch(redirectAfterLogin(redirectPath)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GenericLogin);
